import { AnyAction } from 'redux';

import { ACCOUNT_LAST_CHECKED_UPDATE, PATCH_ACCOUNT_COMPLETED, START_PATCH_ACCOUNT } from '../actions/account-actions';
import { Account } from '../models/account';

export interface AccountReducerState extends Account {
    requestingAccount?: boolean;
}

export const initialAccountReducerState: AccountReducerState = {
    id: -1,
    name: '',
    addresses: [],
    mainContact: undefined,
    lastCheckedDate: new Date(),
    requestingAccount: false,
    accountNeedsToBeChecked: false,
    lastCheckedExpirationThresholdInDays: null,
};

export const accountReducer = (
    state: AccountReducerState = initialAccountReducerState,
    action: AnyAction
): AccountReducerState => {
    const { type } = action;
    switch (type) {
        case ACCOUNT_LAST_CHECKED_UPDATE: {
            return {
                ...state,
                accountNeedsToBeChecked: false,
            };
        }

        case START_PATCH_ACCOUNT: {
            return {
                ...state,
                requestingAccount: true,
            };
        }

        case PATCH_ACCOUNT_COMPLETED: {
            return {
                ...state,
                requestingAccount: false,
            };
        }

        default: {
            return state;
        }
    }
};
